import axios from '@/libs/api.request'
import config from '@/config'

const baseUrl = config.baseContainerUrl + '/api/v1/'

export const NodeUploadTlsUrl = baseUrl + 'upload_tls/'

export const getNodes = (params) => {
  return axios.request({
    url: baseUrl + 'node/',
    params: params,
    method: 'get'
  })
}

export const getAllNodes = (params) => {
  return axios.request({
    url: baseUrl + 'all_nodes_list/',
    params: params,
    method: 'get'
  })
}

export const detailNode = (id) => {
  return axios.request({
    url: baseUrl + 'node/' + id + '/',
    method: 'get'
  })
}

export const changeNode = (data, id) => {
  let url = baseUrl + 'node/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const deleteNode = (id) => {
  return axios.request({
    url: baseUrl + 'node/' + id + '/',
    method: 'delete'
  })
}
